import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarProviderPhotoDeleteResult } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteProviderPhoto = () => {
  const queryClient = useQueryClient()
  const { siteId } = useSugarContext()

  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (photoId: string) => {
      const { data } = await apiClient.delete<SugarProviderPhotoDeleteResult>(
        `/api/provider-profile/photos/${photoId}`
      )
      return data
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ['provider-photos', { siteId }] })
  })

  return {
    deletePhoto: mutateAsync,
    isDeletingPhoto: isPending
  }
}
